import React, {useEffect, useState} from "react";
import {FaSolarPanel, FaUserCog, FaUsers} from "react-icons/fa";
import {FaBorderTopLeft, FaCartShopping, FaQ} from "react-icons/fa6";
import {MdContactSupport, MdDashboard, MdNotifications} from "react-icons/md";
import {useDispatch, useSelector} from "react-redux";
import {Scrollbar} from "react-scrollbars-custom";
import styled from "styled-components";
import {setTOGGLE} from "../Redux/SidebarReducer";
import Logo from "../UI/Header/logo";
import ElementSidebar from "../UI/Sidebar/ElementSidbar";
import ElementSidbarGroup from "../UI/Sidebar/ElementSidbarGroup";
import AdvertisingSidbar from "../UI/Sidebar/AdvertisingSidbar";
import ElementSidbarHr from "../UI/Sidebar/ElementSidbarHr";
import OrderSidbarWithDropDawn from "../UI/Sidebar/OrderSidbarWithDropDawn";
import PanelsElementSidbarDropDown from "../UI/Sidebar/PanelsElementSidbarDropDown";
import SocialGroupsSidebar from "../UI/Sidebar/SocialGroupsSidbar";

import {
    AdUnits,
    Settings,
    ListAlt as SubListIcon,
    Email,
    LandslideRounded,
    Campaign,
    Domain, DomainVerification, Money
} from "@mui/icons-material";
import {MdCategory, MdRateReview} from "react-icons/md";
import {Can} from "../UI/Can";
import ReviewsSidebar from "../UI/Sidebar/ReviewsSidebar";
import MembershipSidebar from "../UI/Sidebar/MembershipSidebar";
import {FiType} from "react-icons/fi";
import {FcMoneyTransfer} from "react-icons/fc";
import {GrTransaction} from "react-icons/gr";
import {BiSolidOffer} from "react-icons/bi";
import {RiAdvertisementFill} from "react-icons/ri";
import DashboardDropdownSidebar from "../UI/Sidebar/SidebarNavigationDropdowns/DashboardDropdownSidebar";
import ServiceDropdownSidebar from "../UI/Sidebar/SidebarNavigationDropdowns/ServiceDropdownSidebar";
import OrderDropdownSidebar from "../UI/Sidebar/SidebarNavigationDropdowns/OrderDropdownSidebar";
import PanelDropdownSidebar from "../UI/Sidebar/SidebarNavigationDropdowns/PanelDropdownSidebar";
import PeobleDropdownSidebar from "../UI/Sidebar/SidebarNavigationDropdowns/PeobleDropdownSidebar";
import UserAdsDropdownSidebar from "../UI/Sidebar/SidebarNavigationDropdowns/UserAdsDropdownSidebar";
import SiteDropdownSidebar from "../UI/Sidebar/SidebarNavigationDropdowns/SiteDropdownSidebar";
import EmailDropdownSidebar from "../UI/Sidebar/SidebarNavigationDropdowns/EmialsDropdownSidebar";
import SupportDropdownSidebar from "../UI/Sidebar/SidebarNavigationDropdowns/SupportDropdownSidebar";

const Styles = styled.div`
  .scrollbar-visible .scrollbar-thumb {
    transition: all.3s;
    background: ${({thememode}) =>
    thememode === "dark"
        ? "rgba(255, 255, 255, 0.4)"
        : "rgba(0, 0, 0, 0.4)"} !important;
  }

  .scrollbar-hidden .scrollbar-thumb {
    background: transparent !important;
    transition: all.3s;
  }

  .scrollbar-thumb:hover {
    background: ${({thememode}) =>
    thememode === "dark" ? "rgba(255, 255, 255, 0.6)" : "rgba(0, 0, 0, 0.6)"};
  }

  .scrollbar-track:hover .scrollbar-thumb {
    background: ${({thememode}) =>
    thememode === "dark"
        ? "rgba(255, 255, 255, 0.4)"
        : "rgba(0, 0, 0, 0.4)"} !important;
  }
`;

const Sidebar = ({thememode}) => {
    const [scrollbarVisible, setScrollbarVisible] = useState(false); // State to manage scrollbar visibility
    const toggle = useSelector((state) => state.Sidebar.toggle);
    const dispatch = useDispatch();

    useEffect(() => {
        const handleResize = () => {
            const isSmallScreen = window.innerWidth <= 768;
            dispatch(setTOGGLE(!isSmallScreen));
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [dispatch]);

    const isAnyModalOpen = useSelector((state) => state.Modal.open);

    const handleScrollStart = () => {
        setScrollbarVisible(true);
    };

    const handleScrollStop = () => {
        setTimeout(() => {
            setScrollbarVisible(false);
        }, 1000);
    };

    return (
        <Styles thememode={thememode}>
            <aside
                className={`list-none text-lg font-medium ${
                    isAnyModalOpen ? "z-20" : "z-30"
                }
         bg-secondary dark:bg-darkPrimary text-darkPrimary dark:text-secondary shadow-lg fixed top-0 duration-300 h-screen overflow-hidden font-sans ${
                    toggle ? "w-60" : "w-0"
                } ${toggle ? "max-md:w-56" : ""} block ${
                    toggle ? "left-0 md:left-0" : "-left-64 md:left-0"
                }`}
                aria-label="Sidebar"
            >
                <Logo thememode={thememode}/>
                <Scrollbar
                    className={`scrollbar-container ${
                        scrollbarVisible ? "scrollbar-visible" : "scrollbar-hidden"
                    }`}
                    style={{height: "calc(100vh - 4rem)"}}
                    thumbYProps={{
                        className: "scrollbar-thumb",
                    }}
                    trackYProps={{
                        className: "scrollbar-track",
                    }}
                    onScrollStart={handleScrollStart}
                    onScrollStop={handleScrollStop}
                >
                    <div>
                        <Can I="stats" a="dashboard">
                            <ElementSidbarGroup title="Home"/>
                            <DashboardDropdownSidebar thememode={thememode}/>
                        </Can>
                        <ElementSidbarHr/>
                        <Can
                            any={[
                                {action: "links", subject: "ourServices"},
                            ]}
                        >
                            <ServiceDropdownSidebar thememode={thememode}/>
                        </Can>
                        <ElementSidbarHr/>
                        <ElementSidbarHr/>

                        <Can
                            any={[
                                {action: "index", subject: "orders"},
                                {action: "store", subject: "orders"},
                                {action: "store", subject: "offerOrders"},
                            ]}
                        >
                            <OrderDropdownSidebar thememode={thememode}/>
                        </Can>
                        <ElementSidbarHr/>
                        <Can
                            any={[
                                {action: "index", subject: "panels"},
                                {action: "store", subject: "panels"},
                            ]}
                        >
                            <PanelDropdownSidebar thememode={thememode}/>
                        </Can>
                        <ElementSidbarHr/>
                        <ElementSidbarHr/>
                        <Can
                            any={[
                                {action: "index", subject: "users"},
                                {action: "index", subject: "employees"},
                                {action: "index", subject: "panelsReviews"},
                                {action: "index", subject: "supportTickets"},
                                {action: "store", subject: "users"},
                                {action: "store", subject: "employees"},
                            ]}
                        >
                            <PeobleDropdownSidebar thememode={thememode}/>
                        </Can>
                        <Can
                            any={[
                                {action: "index", subject: "ads"},
                                {action: "index", subject: "adsCategory"},
                                {action: "index", subject: "adsSubCategory"},
                                {action: "index", subject: "adsSubCategoryType"}
                            ]}
                        >

                            <ElementSidbarHr/>
                            <UserAdsDropdownSidebar thememode={thememode}/>
                        </Can>
                        <Can
                            any={[
                                {action: "index", subject: "adminCampaign"},
                                {action: "index", subject: "userCampaign"}
                            ]}
                        >

                            <ElementSidbarHr/>
                            <EmailDropdownSidebar thememode={thememode}/>
                        </Can>
                        <Can
                            any={[
                                {action: "index", subject: "sliders"},
                                {action: "index", subject: "faqs"},
                                {action: "index", subject: "settings"}
                            ]}
                        >

                            <ElementSidbarHr/>
                            <SiteDropdownSidebar thememode={thememode}/>
                        </Can>
                        <ElementSidbarHr/>
                        <SupportDropdownSidebar thememode={thememode}/>

                        <ElementSidbarHr/>
                        <ElementSidebar
                            title="Notification"
                            link="Notification"
                            icon={MdNotifications}
                        />
                    </div>
                </Scrollbar>
            </aside>
        </Styles>
    );
};

export default Sidebar;
